import debounce from '../utils/debounce'
export default class Map {
    constructor() {
        this.mapContainer = document.querySelector('.map-svg')
        this.map = this.mapContainer.querySelector('svg')
        this.countries = this.map.querySelectorAll('#countries *')
        this.details = this.mapContainer.querySelector('.map-svg__details')
        this.close = this.mapContainer.querySelector('.map-svg__details-close')

        this.countries.forEach((el) => {
            el.addEventListener('click', () => {
                this.updateCountry(el)
                this.updateDetails(el)
            })
        })
        this.resize()
        window.addEventListener('resize', debounce(() => {this.resize()}, 300))

        this.close.addEventListener('click', this.closeDetails.bind(this))
    }

    updateCountry(el) {
        const active = this.map.querySelector('.active');
        if (active) {
            active.classList.remove('active');
        }
        el.classList.add('active');
    }

    updateDetails(el) {

        const params = JSON.parse(el.getAttribute('data-params'));
        const pos = JSON.parse(el.getAttribute('data-pos'));

        this.details.classList.remove('visible')
        setTimeout(() => {
            if (pos) {
                if (window.innerWidth >= 1024) {
                    this.details.style.top = `${pos.top}%`
                    this.details.style.left = `${pos.left}%`
                } else {
                    this.details.style.top = null
                    this.details.style.left = null
                }

                this.details.classList.add('visible')
                const groups = document.querySelectorAll('.map-svg__details-group')

                document.querySelector('.map-svg__details-country').innerHTML = params.name
                groups.forEach((e) => {
                    console.log(!!params[key])
                    const key = e.getAttribute('data-value');
                    e.setAttribute('data-number', params[key] ? params[key] : 0)
                    e.querySelector('.number').innerHTML = params[key]
                })
            }
        }, 300)
    }

    resize() {
        if (window.innerWidth >= 1024) {
            this.details.classList.add('visible');
        } else {
            this.details.classList.remove('visible');
        }
    }
    
    closeDetails() {
        this.details.classList.remove('visible');
    }
}